<template>
  <learning-page-hero
    :id="id"
    :headline="computedHeadline"
    :subheadline="computedSubheadline"
    :cta="computedCta"
    :href="computedHref"
    :open-signup="openSignup"
  />
</template>

<script>
import LearningPageHero from "../components/learning-page-hero"
import globals from "@/utils/globals"

export default {
  name: "LearningPageHeroController",
  components: {
    LearningPageHero
  },
  onboardingPath: globals.onboardingPath,
  props: {
    id: { type: String, default: null },
    headline: { type: String, default: null },
    subheadline: { type: String, default: null },
    cta: { type: String, default: null },
    href: { type: String, default: null },
    i18nKey: { type: String, default: "default" }
  },
  computed: {
    computedHeadline() {
      return this.computeCopyProp("headline", "&nbsp;<br />&nbsp;")
    },
    computedSubheadline() {
      return this.computeCopyProp("subheadline", "&nbsp;<br />&nbsp;")
    },
    computedCta() {
      return this.computeCopyProp("cta", "&nbsp;")
    },
    computedHref() {
      return this.computeCopyProp("href", "#")
    },
    openSignup() {
      return true
    }
  },
  methods: {
    computeCopyProp(prop) {
      return this[prop] || this.$t(`${this.i18nKey}.${prop}`)
    }
  },
  i18n: {
    messages: {
      en: {
        default: {
          cta: "Start free trial",
          headline: "Fit learning into your&nbsp;life",
          subheadline:
            "Blinkist brings you knowledge from top nonfiction and podcasts, so you can learn anytime, anywhere.",
          href: "/signup"
        },
        homepage: {
          cta: "Start free trial",
          ctaVariation: "Try it free for 7 days",
          headline: "Fit learning into your&nbsp;life",
          subheadline:
            "Blinkist brings you knowledge from top nonfiction and podcasts, so you can learn anytime, anywhere.",
          href: "/signup"
        }
      },
      de: {
        default: {
          cta: "Jetzt kostenlos testen",
          headline: "Bring mehr Wissen in deinen Alltag",
          subheadline:
            "Blinkist ist eine App, die Wissen auf dein Smartphone bringt. Zum Lesen und Anhören in 15-minütigen Blinks, innovativen Audioformaten oder Hörbüchern in voller Länge.",
          href: "/signup"
        },
        homepage: {
          cta: "Jetzt kostenlos testen",
          ctaVariation: "Jetzt kostenlos testen",
          headline: "Bring mehr Wissen in deinen Alltag",
          subheadline:
            "Blinkist ist eine App, die Wissen auf dein Smartphone bringt. Zum Lesen und Anhören in 15-minütigen Blinks, innovativen Audioformaten oder Hörbüchern in voller Länge.",
          href: "/signup"
        }
      },
      es: {
        default: {
          cta: "Empieza tu prueba gratuita",
          headline: "Integra el aprendizaje en tu vida",
          subheadline:
            "Blinkist te ofrece conocimientos de los mejores libros de no ficción y podcasts, para que puedas aprender en cualquier momento y lugar.",
          href: "/signup"
        },
        homepage: {
          cta: "Empieza tu prueba gratuita",
          ctaVariation: "Pruébalo gratis",
          headline: "Integra el aprendizaje en tu vida",
          subheadline:
            "Blinkist te ofrece conocimientos de los mejores libros de no ficción y podcasts, para que puedas aprender en cualquier momento y lugar.",
          href: "/signup"
        }
      }
    }
  }
}
</script>
